import React, { useState } from "react";
import TopNavPageHeader from "@src/features/app/top-nav/TopNavPageHeader";
import { Button } from "@src/lib/ui/Button";
import ArrowUploadIcon from "@src/lib/icons/18px/arrow-upload";
import AddGuestFeedbackIntegrationButton from "./AddGuestFeedbackIntegrationButton";
import GuestFeedbackUploadCSVDialog from "./GuestFeedbackUploadCSVDialog";

const GUEST_FEEDBACK_HELP_LINK =
  "https://help.opus.so/en/articles/11816562-guest-feedback-integration-overview-beta";

type Props = {
  showActions?: boolean;
};

const GuestFeedbackPageHeader: React.FC<Props> = ({ showActions = true }) => {
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  return (
    <>
      <TopNavPageHeader
        subtitle="Browse guest reviews and manage your connected feedback sources."
        description="Browse guest reviews and manage your connected feedback sources."
        learnMoreLink={GUEST_FEEDBACK_HELP_LINK}
        actions={
          showActions ? (
            <>
              <AddGuestFeedbackIntegrationButton variant="outline" />
              <Button
                variant="outline"
                size="md"
                onClick={() => setUploadDialogOpen(true)}
              >
                <ArrowUploadIcon />
                Upload CSV
              </Button>
            </>
          ) : undefined
        }
      />
      <GuestFeedbackUploadCSVDialog
        open={uploadDialogOpen}
        onOpenChange={setUploadDialogOpen}
      />
    </>
  );
};

export default GuestFeedbackPageHeader;
